import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DateTime } from "luxon";
import { Box } from "@mui/system";
import DateRangeIcon from "@mui/icons-material/DateRange";
import theme, { padding } from "../../../theme";
import { CustomDateRangePicker } from "./customRangePicker";
import { ArrowCircleLeft, ArrowCircleRight } from "@mui/icons-material";
import Close from "@mui/icons-material/Close";
import { ClickOutsideWrapper } from "../ClickOutsideWrapper";
import { TagButton, TagButtons } from "./tagButtons";
import { IconButton } from "@mui/material";


export const DateRangePickerPopUp = ({
  startDate,
  endDate,
  onStartDatePicked,
  onEndDatePicked,
  presets,
  setOpen,
  open,
  customDateRangePicker
}: {
  startDate: DateTime;
  endDate: DateTime;
  onStartDatePicked: Function;
  onEndDatePicked: Function;
  presets?: TagButton[]
  setOpen: Function
  open: boolean
  customDateRangePicker?: boolean
}) => {

  const isMobile = useSelector(
    (state: any) => state.dimensions.device === "mobile"
  );
  const [selected, setSelected] = useState<TagButton>();
  useEffect(() => {
    if (!selected)
      presets?.map((p) => {
        if (p.default === true) {
          setSelected(p)
        }
      })
  }, [presets, selected])

  useEffect(() => {
    if (!endDate) {
      setSelected({ name: "", id: "custom", action: () => console.log() })
    }
  }, [endDate])

  const stepper = endDate?.diff(startDate, "days").days <= 7 ? { week: 1 } : { month: 1 }
  const step = endDate?.diff(startDate, "days").days <= 7 ? "week" : "month"
  const today = DateTime.now();

  return (
    <div style={{ marginBottom: padding * 2, marginTop: padding * 2 }}>
      <ClickOutsideWrapper onClickOutside={setOpen} >
        <Box
          sx={{
            width: isMobile ? 275 : 350,
            height: 40,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            border: "1px #868686 solid",
            paddingLeft: padding / 4,
            paddingRight: padding / 4,
            borderRadius: 1,
          }}
        >
          <IconButton 
            onClick={() => {
              setSelected(undefined)
              onStartDatePicked(startDate?.minus(stepper).startOf(step));
              onEndDatePicked(startDate?.minus(stepper).endOf(step));
              setSelected({ name: "", id: "custom", action: () => console.log() })
            }}
            sx={{color: theme.palette.primary.main, padding: "0px"}}
            >
            <ArrowCircleLeft/>
          </IconButton>
          <Box
            onClick={() => setOpen(!open)}
            sx={{
              width: 250,
              display: "flex",
              flex: 1,
              justifyContent: "center",
              flexDirection: "row",
              alignItems: "center",
              paddingLeft: padding / 2,
              paddingRight: padding / 2,
              "&:hover": {
                cursor: "pointer",
              },
            }}
          >
            <DateRangeIcon sx={{ marginRight: padding / 2 }} />
            {
              endDate?.diff(startDate, "days").days <= 1 ?
                <p style={{ fontSize: isMobile ? 14 : 14 }}>
                  {startDate?.toFormat("dd LLL")}
                </p> :
                startDate?.weekNumber === today.minus({ week: 1 }).weekNumber &&
                  startDate?.weekNumber === endDate?.weekNumber && endDate?.diff(startDate, "days").days === 6 ? (
                  <p style={{ fontSize: isMobile ? 14 : 14 }}>Last week</p>
                ) : (
                  <p style={{ fontSize: isMobile ? 14 : 14 }}>
                    {startDate?.toFormat("dd LLL")} - {endDate?.toFormat("dd LLL")}
                  </p>
                )}
            {startDate?.weekNumber === endDate?.weekNumber && !isMobile ? (
              <p style={{ marginLeft: padding, color: "grey", fontSize: 14 }}>
                &#183; {"W" + startDate?.weekNumber}
              </p>
            ) : (
              <></>
            )}
          </Box>
          <IconButton 
            onClick={() => {
              if (!endDate) return
              if (endDate.plus(stepper).startOf(step) <= today.startOf(step)) {
                onStartDatePicked(endDate?.plus(stepper).startOf(step));
                onEndDatePicked(endDate?.plus(stepper).endOf(step));
                setSelected({ name: "", id: "custom", action: () => console.log() })
              }
            }}
            disabled={!endDate || endDate?.plus(stepper).startOf(step) > today.startOf(step)}
            sx={{color: theme.palette.primary.main, padding: "0px"}}
              >
            <ArrowCircleRight/>
          </IconButton>
        </Box>

        {open && (
          <div
            style={{
              marginTop: padding,
              flexDirection: "column",
              display: "flex",
              boxShadow: "2px 2px 10px 0px #868686",
              position: "absolute",
              backgroundColor: "white",
              zIndex: 10,
              borderRadius: 2,
            }}
          >
            <Close
              sx={{
                borderRadius: 2,
                color: theme.palette.background.default,
                margin: padding / 8,
                flexDirection: "row",
                alignSelf: "end",
                "&:hover": {
                  cursor: "pointer",
                  bgcolor: theme.palette.background.default,
                  color: "white",
                },
              }}
              onClick={() => setOpen(false)}
            />
            <div
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                paddingRight: padding,
              }}
            >
              <TagButtons
                direction={isMobile ? "row" : "column"}
                tagButtons={presets}
                selected={selected}
                setSelected={setSelected}
              ></TagButtons>
              {!customDateRangePicker && (
                <CustomDateRangePicker
                  isMobile={isMobile}
                  setEndDate={onEndDatePicked}
                  setStartDate={onStartDatePicked}
                  startDate={startDate}
                  endDate={endDate}
                />
              )}
            </div>
          </div>
        )}
      </ClickOutsideWrapper>
    </div>
  );
};

